import React from "react";

const DescriptionBasic = () => {
  return (
    <div className="bg-white rounded-2xl mx-auto p-6">
      <h2 className="text-2xl font-bold text-baseBlue mb-4">
        Basic Armwrestling Course
      </h2>
      <p className="text-baseBlue leading-relaxed mb-4">
        Start your journey into the world of arm wrestling with our
        <strong className="text-baseBlue">
          {" "}
          Basic Armwrestling Course!
        </strong>{" "}
        Perfect for beginners, it covers foundational techniques, training tips,
        and strategies to build strength and confidence at the table.
      </p>
      <p className="text-baseBlue leading-relaxed mb-4">
        In this course, you will learn a lot about arm wrestling training, the
        meaning behind these training methods, training schedules, pulling tips,
        and much more!
      </p>
      <div className="bg-gray-100 border-l-4 border-baseBlue p-4 text-baseBlue rounded-lg">
        <p className="leading-relaxed font-semibold">
          🎯 The course is in Georgian with English subtitles, making it easy to
          follow along. Plus, it includes a live private consultation with the
          coach! We're here to support you every step of the way.
        </p>
      </div>
    </div>
  );
};

export default DescriptionBasic;
